import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_BEGIN,
  USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_SUCCESS,
  USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_FAILURE,
  USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function getSubscriptionStatusByEmail(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/subscriptions/get-subscription-status-by-email/${args.email}`,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetSubscriptionStatusByEmailError() {
  return {
    type: USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_DISMISS_ERROR,
  };
}

export function useGetSubscriptionStatusByEmail() {
  const dispatch = useDispatch();

  const {
    getSubscriptionStatusByEmailPending,
    getSubscriptionStatusByEmailError,
  } = useSelector(
    (state) => ({
      getSubscriptionStatusByEmailPending:
        state.user.getSubscriptionStatusByEmailPending,
      getSubscriptionStatusByEmailError:
        state.user.getSubscriptionStatusByEmailError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    async (...args) => {
      return dispatch(getSubscriptionStatusByEmail(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetSubscriptionStatusByEmailError());
  }, [dispatch]);

  return {
    getSubscriptionStatusByEmail: boundAction,
    getSubscriptionStatusByEmailPending,
    getSubscriptionStatusByEmailError,
    dismissGetSubscriptionStatusByEmailError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSubscriptionStatusByEmailPending: true,
        getSubscriptionStatusByEmailError: null,
      };

    case USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_SUCCESS:
      // The request is success
      return {
        ...state,
        getSubscriptionStatusByEmailPending: false,
        getSubscriptionStatusByEmailError: null,
      };

    case USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        getSubscriptionStatusByEmailPending: false,
        getSubscriptionStatusByEmailError: action.data.error,
      };

    case USER_GET_SUBSCRIPTION_STATUS_BY_EMAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSubscriptionStatusByEmailError: null,
      };

    default:
      return state;
  }
}
